/* MOST mobile filters: portal the overlay to body to escape theme stacking contexts. */
(function(){
  if(window.__mostFiltersReady)return;
  window.__mostFiltersReady=true;
  var activeShell=null,activeDrawer=null,activeBackdrop=null,oldOverflow='',returnFocus=null;
  function getShell(element){return element&&element.closest('[data-most-mf]')}
  function openDrawer(shell,trigger){
    if(!shell)return;
    if(activeShell)closeDrawer();
    var drawer=shell.querySelector('.most-mf-drawer')||document.getElementById('MostMobileFilters');
    var backdrop=shell.querySelector('.most-mf-backdrop')||document.querySelector('.most-mf-backdrop');
    if(!drawer||!backdrop)return;
    oldOverflow=document.body.style.overflow;
    returnFocus=trigger;
    activeShell=shell;activeDrawer=drawer;activeBackdrop=backdrop;
    if(backdrop.parentNode!==document.body)document.body.appendChild(backdrop);
    if(drawer.parentNode!==document.body)document.body.appendChild(drawer);
    shell.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    drawer.focus();
  }
  function closeDrawer(){
    if(!activeShell)return;
    activeShell.classList.remove('is-open');
    if(activeBackdrop)activeBackdrop.classList.remove('is-open');
    if(activeDrawer){
      activeDrawer.classList.remove('is-open');
      activeDrawer.setAttribute('aria-hidden','true');
    }
    document.body.style.overflow=oldOverflow;
    if(returnFocus&&document.contains(returnFocus))returnFocus.focus();
    activeShell=null;activeDrawer=null;activeBackdrop=null;returnFocus=null;
  }
  document.addEventListener('click',function(ev){
    var trigger=ev.target.closest('[data-most-mf-open]');
    if(trigger){ev.preventDefault();openDrawer(getShell(trigger),trigger);return;}
    if(ev.target.closest('[data-most-mf-close]')){ev.preventDefault();closeDrawer();}
  });
  document.addEventListener('keydown',function(ev){
    if(!activeDrawer)return;
    if(ev.key==='Escape'){ev.preventDefault();closeDrawer();return;}
    if(ev.key!=='Tab')return;
    var fields=Array.from(activeDrawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),summary')).filter(function(el){return el.getClientRects().length>0});
    if(!fields.length)return;
    if(ev.shiftKey&&document.activeElement===fields[0]){ev.preventDefault();fields[fields.length-1].focus();}
    else if(!ev.shiftKey&&document.activeElement===fields[fields.length-1]){ev.preventDefault();fields[0].focus();}
  });
  document.addEventListener('input',function(ev){
    var target=ev.target;
    if(!target.matches('[data-most-min],[data-most-max],[data-most-range-min],[data-most-range-max]'))return;
    var group=target.closest('.most-mf-group');if(!group)return;
    var min=group.querySelector('[data-most-min]');
    var max=group.querySelector('[data-most-max]');
    var rangeMin=group.querySelector('[data-most-range-min]');
    var rangeMax=group.querySelector('[data-most-range-max]');
    if(!min||!max||!rangeMin||!rangeMax)return;
    var isMin=target===min||target===rangeMin;
    var number=isMin?min:max,range=isMin?rangeMin:rangeMax;
    var other=isMin?max:min,otherRange=isMin?rangeMax:rangeMin;
    var limit=Number(rangeMax.max)||0;
    if(target===rangeMin||target===rangeMax)number.value=target.value;
    if(number.value===''){range.value=isMin?0:limit;return;}
    var next=Math.min(limit,Math.max(0,Number(number.value)));
    if(other.value!==''&&((isMin&&next>Number(other.value))||(!isMin&&next<Number(other.value)))){
      other.value=next;otherRange.value=next;
    }
    number.value=next;range.value=next;
  });
})();